import anime, {AnimeTimelineInstance} from 'animejs'

export class ProgressImageAnimation {
  tl: AnimeTimelineInstance | null = null
  elements: HTMLDivElement[] = []
  delay = 0

  seek(per: number) {
    this.tl?.seek(this.tl?.duration * per)
  }

  init(elements: HTMLDivElement[], delay = 0) {
    this.elements = elements
    this.delay = delay

    this.tl = anime.timeline({
      easing: 'easeOutCubic',
      autoplay: false,
    })

    this.elements.map((item, index) => {
      item.style.opacity = index === 0 ? '1' : '0'
      item.style.transform = index === 0 ? '' : 'scale(1.10)'
      item.style.transition = 'none'
      const isFirst = index === 0
      const isLast = index === this.elements.length - 1
      this.tl?.add({
        duration: 10000,
        targets: item,
        opacity: isFirst ? 1 : [0, 1],
        scale: 1,
      }, '-=2500')
      if (!isLast) {
        // 消える時
        this.tl?.add({
          duration: 2000,
          targets: item,
          opacity: 0,
        })
      }
    })

  }

}
